import { render, staticRenderFns } from "./CreditedGitInvoice.vue?vue&type=template&id=6571c04a&scoped=true&"
import script from "./CreditedGitInvoice.vue?vue&type=script&lang=js&"
export * from "./CreditedGitInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6571c04a",
  null
  
)

export default component.exports